import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import noteContext from "../context/notes/noteContext";

const EditNote = (props) => {
  let navigate = useNavigate();
  document.title = props.title;
  useEffect(() => {
    props.showLoading()
    if(!localStorage.getItem('auth-token')){
      navigate('/auth/login')
    }
    setTimeout(()=>{
      props.completeLoading()
    },100)
  }, [])
  const context = useContext(noteContext);
  const { editNote } = context;

  // Fetching Notes from NoteId
  let url = new URL(window.location);
  let noteId = url.searchParams.get("noteId");
  let noteTitle;
  let noteDescription;
  let noteTag;
  if (
    url.searchParams.get("tag") === null &&
    url.searchParams.get("description") === null
  ) {
    noteTitle = "Enter Your Title";
    noteDescription = "Enter Your Description";
    noteTag = "";
  } else {
    noteTitle = url.searchParams.get("title");
    noteDescription = url.searchParams.get("description");
    noteTag = url.searchParams.get("tag");
  }

  const [note, setNote] = useState({
    etitle: noteTitle,
    edescription: noteDescription,
    etag: noteTag,
  });
  const onChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
  };

  const handleUpdateNoteBtn = (e) => {
    e.preventDefault();
    if(note.edescription.length<4){
      props.showAlert('warning', "Warning", "Description Must Be 4 Character Long")
    }else{
      if (note.etitle !== "" && note.edescription !== "") {
        let selectedTag = document.getElementById("tag");
        if (selectedTag.value !== "") {
          let tag =
            selectedTag.value.substr(0, 1).toUpperCase() +
            selectedTag.value.slice(1);
          editNote(noteId, note.etitle, note.edescription, tag);
        } else {
          editNote(noteId, note.etitle, note.edescription);
        }
        navigate("/");
      }
    }
  };

  return (
    <div
      className={`container px-5 my-4 ${
        props.theme === "dark" ? "text-light" : ""
      }`}
    >
      <span className="float-end">
        Fields with (<span className="text-danger">*</span>) are required
      </span>
      <h1 className="text-center">Edit Your Note</h1>
      <form onSubmit={handleUpdateNoteBtn}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">
            Enter Note Title<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            id="etitle"
            name="etitle"
            aria-describedby="emailHelp"
            onChange={onChange}
            required
            value={note.etitle}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Enter Note Description<span className="text-danger">* </span>
            <span className="text-secondary"> (Min. 4 characters)</span>
          </label>
          <textarea
            rows={5}
            type="text"
            className={`form-control ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            id="edescription"
            name="edescription"
            onChange={onChange}
            required
            value={note.edescription}
          ></textarea>
        </div>
        {note.etag !== "" ? (
          <select
            className={`form-select form-select-lg mb-3 ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            name="tag"
            defaultValue={note.etag.toLowerCase()}
            id="tag"
            aria-label=".form-select-lg example"
          >
            <option value="">Choose Tag For Note</option>
            <option value="general">General</option>
            <option value="personal">Personal</option>
            <option value="official">Official</option>
            <option value="others">Others</option>
          </select>
        ) : (
          ""
        )}
        <button type="submit" className="btn btn-primary">
          Update Note
        </button>
      </form>
    </div>
  );
};

export default EditNote;
